"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EASE_LAPSED_DIFF = exports.EASE_DIFF = void 0;
// These represent percentage points.
exports.EASE_DIFF = 15;
exports.EASE_LAPSED_DIFF = 20;
